/**
 * Single canonical list of ESC/POS codepages offered anywhere in the app
 * (edit modals, wizard symbol flows, mega codepage test). Desktop's
 * V2_CODEPAGES and native's TEST_CODEPAGES re-export from here — the sets
 * were byte-identical copies before this file existed.
 *
 * Order matters: the mega codepage test prints one line per entry in this
 * order, and users pick by position.
 */
export const PRINTER_CODEPAGES = [
  'cp437',
  'cp737',
  'cp850',
  'cp775',
  'cp852',
  'cp855',
  'cp857',
  'cp858',
  'cp860',
  'cp861',
  'cp862',
  'cp863',
  'cp864',
  'cp865',
  'cp866',
  'cp869',
  'cp936',
  'cp949',
  'cp950',
  'cp1252',
  'iso88596',
  'shiftjis',
  'windows1250',
  'windows1251',
  'windows1252',
  'windows1253',
  'windows1254',
  'windows1255',
  'windows1256',
  'windows1257',
  'windows1258',
] as const;

export type PrinterCodepage = (typeof PRINTER_CODEPAGES)[number];

/** Listbox-ready items ({ id, label }) for codepage pickers. */
export const CODEPAGE_ITEMS: { id: string; label: string }[] =
  PRINTER_CODEPAGES.map((cp) => ({ id: cp, label: cp }));
